// extracted by mini-css-extract-plugin
module.exports = {"inlineInfoTitle":"invoicebasicinfocard_inlineInfoTitle__4B81v"};